import React from 'react'
import './Recipe.css'
import {Link } from 'react-router-dom'  
import {TooltipNo} from '../../atoms'
import {Popup} from '../../organisms'
import { useRef } from 'react'; 
import { meals } from "../../../constants/constants.js";
import { priceDish, Cals } from "../../../utils/utils.js";
import { useSelector, useDispatch } from 'react-redux'
import {  changeLikeRecipe, changeDisLikeRecipe, addMenuDish, postPlanManual, acceptRecipeUser } from '../../../store/api.js' 

export const Recipe = (props) => {
  const recipe = props.recipe
  const dispatch = useDispatch()
  const { lib, statusLib } = useSelector(state => state.lib)  
  const {ingredients, status} = useSelector(state => state.ingredients)
  const { currentUser, recipeOwner } = useSelector(state => state.currentUser)
  const [kitchenware, setКitchenware] = React.useState([]);   
  //const kitchenware = recipe.kitchenware.filter(t=> t.boolean).slice(0, 3) 
  const [isOpen, setIsOpen] = React.useState(false)  
  const [showCalendar, setShowCalendar] = React.useState(false)  // Показывает календарь
  const ingRef =  useRef()
  const [author, setAuthor] = React.useState('') 
  const positionMenuItem = props.positionMenuItem
  const eventRef = React.useRef()
  const isLiked = recipe.likes.some(i => i === currentUser._id)  
  const isDisLiked = recipe.disLikes.some(i => i === currentUser._id) 
  const time = recipe.times && recipe.times.find(t=> t.timeKey === 'basic')
  let price = priceDish(recipe.ingredients, ingredients)
  const fullIngredients = recipe.ingredients.map(shortIngredient => { 
    const findIng = ingredients.find(fullIngredient => fullIngredient._id === shortIngredient._id); 
    return {
      ...shortIngredient,
      name: findIng ? findIng.name : null  // Проверяем, найден ли ингредиент
    };
  });
 
  React.useEffect(() => {
     if (statusLib !== 'resolved') return 
     setКitchenware( lib.kitchenware.filter((item) => recipe.kitchenwareRefs.includes(item._id)).slice(0,3))
  }, [statusLib])
 
  React.useEffect(() => {
    const click = e => {
      if (isOpen && ingRef.current && !ingRef.current.contains(e.target) && !e.target.classList.contains('ingtoggle') ) {
        setIsOpen(false)
      }
    }
    document.addEventListener("mousedown", click)
    return () => {
      document.removeEventListener("mousedown", click)
    }
  }, [isOpen])

  React.useEffect(() => {
    const click = e => {
      if (showCalendar && eventRef.current && !eventRef.current.contains(e.target) && !e.target.classList.contains('caltoggle') ) {
        setShowCalendar(false)
      }
     }
    document.addEventListener("mousedown", click)
      return () => {
        document.removeEventListener("mousedown", click)
      }
    }, [showCalendar])
  
  //Обработка строки автора
  function searchAuthor() { 
    if(recipe.link) {
      return new URL(recipe.link).hostname 
    } else {
      return recipe.owner
    }  
  }
  function handlePopupModal() {
    setIsOpen(!isOpen)
  }

  function handleChangeEvents(el) { 
    setIsOpen(false)
  } 
  
  //Открытие и закрытие календаря для добавления в рецепт
  function handleOpenCalendar() { 
    setShowCalendar(!showCalendar)
  }

  function handleAddRecipeinMeals(el) {
    setShowCalendar(false)
    dispatch(postPlanManual({date: el.dataDate, mealType: el.title.mealsEn, recipeId: recipe._id}))
  }

    // Добавление и удаление лайков
    function handleLikeClick () { 
        dispatch(changeLikeRecipe({id: recipe._id, isLiked: !isLiked}))
      }
    
      // Добавление и удаление дизлайков
      function handleDisLikeClick () { 
        dispatch(changeDisLikeRecipe({id: recipe._id, isDisLiked: !isDisLiked}))
      }
  
  function convertWeightToMainMeasure(ingredient, baseIngredient) {
    const measure = baseIngredient.measure.find(m => m.nameRu === ingredient.choisMeasure);
    return measure ? measure.ratio * ingredient.weight : ingredient.weight; // Если вес в другой мере, переводим
  }
    
  function calculateIngredientPrice(ingredient, baseIngredient) {
    const weightInMainMeasure = convertWeightToMainMeasure(ingredient, baseIngredient);
   const pricePerMainMeasure = baseIngredient.price.rate / baseIngredient.price.weightprice;
    return pricePerMainMeasure * weightInMainMeasure; // Цена = цена за основную меру * переводимый вес
  }
 
  function handleDate(date) { 
   
  }
  
  function handleAddRecipe() {   
   dispatch(acceptRecipeUser(recipe._id ))
  } 

  return (
    <article className={`recipe recipe__${props.type} `} > 
      <div className="recipe__img_container">
      
      <Link to={`/recipes/${recipe._id}`} target="_blank" className=" color-title" > 
        <img className="recipe__image" src={recipe.image[0]} alt={recipe.name} />
       </Link>
       
        <div className="recipe__gradient"> </div> 
        <div className="recipe__image_grad-info">
        <div className="recipe__image_grad-icon">
          <p className='recipe__category font14Norm'>{recipe.category}</p>
         
            <div className='ml-a df-r ai-c g10'>
              <p className='gg-delete-white xlm-size' onClick={()=> props.handleDeleteRecipe(recipe)}></p>
              <p className='gg-edit-white xlm-size' onClick={( ) => props.handleEditRecipe(recipe) }></p> 
              <span className='gg-done x-size' onClick={handleAddRecipe}> </span> 
            </div>  
          
        
        </div> 
        
      </div>
      </div>
      <div className='recipe__content'>
      <p className='font14Norm'>Статус: {recipe.status}   </p>
      <p className='font14Norm'>Источник: 
            <a href={`${recipe.link !=='' ? recipe.link : '#'}`} 
              target='_blank' rel="noreferrer" 
              className='recipe__link font14Norm colorGrey'>{searchAuthor(recipe)}</a>
          </p>
      <Link to={`/recipes/${recipe._id}`} target="_blank" className=" color-title" > <h3 className=' font20B'>{recipe.name}</h3> </Link>
        <div className='recipe__info'>
        <div className='recipe__block'>
          <div className='recipe__icon_text' > <p className='gg-cooking font14Norm color' ></p> <p className=' font14Norm'>{time ? time.time : recipe.time} {time ? time.unitСhoice : 'мин'}</p></div>  
          <div className='recipe__icon_text' > <p className='gg-coin font14Norm color' ></p> <p className=' font14Norm'> {Math.round(price/recipe.servings)} ₽</p></div>  
          <div className='recipe__icon_text' > <p className='gg-dish font14Norm color' ></p> <p className=' font14Norm'>{Math.round(recipe.calories.totalWeight/recipe.servings)} г</p></div>  
        </div>  
        <ul className='recipe-card__block_calories recipe__block_cals'> 
          <Cals num={Math.ceil(recipe.calories.protein/recipe.servings)} name='Б' measure='г'/>
          <Cals num={Math.ceil(recipe.calories.fats/recipe.servings)} name='Ж' measure='г'/>
          <Cals num={Math.ceil(recipe.calories.carb/recipe.servings)} name='У' measure='г'/> 
          <Cals num={Math.ceil(recipe.calories.calories/recipe.servings)} measure='ккал'/>
        </ul>
        <div className='recipe__block'>
          <div className='recipe__block_R50 fw'>
          { kitchenware.length > 0 &&
              kitchenware.map((t, index)=> (
                <Tools key={index} icon={t.nameEn} item={t}/>
              )) 
              } 
           
            </div>  
            <div className='recipe__block_R50 '>
            <p className='recipe__ing font14Norm' onClick={handlePopupModal}>Ингредиенты <span className={`ingtoggle ${!isOpen ? 'gg-poligon-down' : 'gg-poligon-up'} s-12-10`}> </span> </p> 
        <Popup isOpen={isOpen} ref={ingRef} type='with-toggle'>
          {fullIngredients.map((el, index) => <p className='ing-text font12Norm' key={index} onClick={()=> handleChangeEvents(el)}>
            <span>  
              {el.name} </span>  
              <span>  
              {el.weight}   {el.choisMeasure}</span>  
          </p>)} 
        </Popup> 
          </div>
        </div>  
        </div> 
        </div>   
  </article>
  )
};

 
  
const Tools = ({icon, item}) => {
    return  ( 
      <TooltipNo content={item.nameRu}>
         <p className={`tools-sm tool-${icon}`}></p>
      </TooltipNo>
    )
  }